export { DtvText as default } from "./dtv-text";
export type { IDtvTextProps } from "./dtv-text";
